import React, { useEffect } from 'react'
import ReactSVG from 'react-svg'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useMutation } from 'react-apollo'
import { useHistory } from 'react-router-dom'

import { getFormattedDate } from '../utils/get-formatted-date'
import { segmentTrackCancelJourney } from '../../../segment/segment-track'
import {
  ACCOUNT_SCREENS,
  CANCEL_SUBSCRIPTION_SCREENS,
  EV_SUBSCRIPTION_STATUS,
  MANAGE_PLAN_OPTIONS
} from '../../../constants'
import { CANCEL_JOURNEY_BUTTONS } from '../../../segment/constants'
import UndoIcon from '../../../../images/undo-icon.svg'
import REACTIVATE_SUBSCRIPTION_MUTATION from '../../../../graphql/mutations/reactivate-subscription.gql'
import Button from '../../button'
import styles from '../cancel-subscription.css'

function CancelInfo({ activeSubscription, email }) {
  const history = useHistory()

  const cta = 'UNDO CANCEL REQUEST'

  const formattedEndDate = getFormattedDate(['currentSubscription', 'endsAt'], activeSubscription)

  const hasResumeOption = activeSubscription?.manageSubsOptions?.includes(MANAGE_PLAN_OPTIONS.RESUME)

  // Reactivate subscription mutation (Undo Cancel request)
  const [
    reactivateSubscription,
    { loading, error, data }
  ] = useMutation(REACTIVATE_SUBSCRIPTION_MUTATION)

  const reactivateSubscriptionHnadler = () => {
    const sku = activeSubscription.currentSubscription?.sku ?? ''

    const upcomingFinalBillSku = activeSubscription.upcomingFinalBillSubscription?.sku ?? ''

    const evUpcomingSubscriptionStatus =
      activeSubscription.upcomingSubscription?.evSubscriptionStatus ??
      activeSubscription.upcomingFinalBillSubscription?.evSubscriptionStatus

    const isUpcomingCancelled = evUpcomingSubscriptionStatus === EV_SUBSCRIPTION_STATUS.FINAL_BILL

    const reactivationSku = isUpcomingCancelled && upcomingFinalBillSku ? upcomingFinalBillSku : sku

    reactivateSubscription({
      variables: {
        sku: reactivationSku
      }
    })

    // Track cancel journey event
    segmentTrackCancelJourney({
      step: CANCEL_SUBSCRIPTION_SCREENS.CANCEL_SUBSCRIPTION_CONFIRMATION.name,
      buttonClicked: CANCEL_JOURNEY_BUTTONS.UNDO_CANCELLATION
    })
  }

  useEffect(() => {
    if (!loading && data?.reactivateSubscription.success) {
      history.replace(ACCOUNT_SCREENS.SUBSCRIPTION_PAYMENT.path)
    }
  }, [data, error, loading])

  return (
    <div className={classnames(styles.section, styles.noTopMargin)}>
      <div className={styles.header}>
        Your subscription is cancelled
      </div>
      <div className={styles.copy}>
        You can keep watching Neon until your subscription ends on&nbsp;
        <span className={styles.bold}>{formattedEndDate}</span>
        .
        <br />
        A confirmation will be sent to&nbsp;
        <span className={styles.bold}>{email}</span>
        {hasResumeOption && (
          <>
            <br />
            <br />
            If you change your mind, you can undo this request to continue watching all Neon has to offer.
            <Button
              className={styles.button}
              onClick={reactivateSubscriptionHnadler}
              disabled={loading}
              secondary
            >
              <div className={styles.iconButton}>
                <ReactSVG src={UndoIcon} />
                {cta}
              </div>
            </Button>
          </>
        )}
      </div>
    </div>
  )
}

CancelInfo.propTypes = {
  activeSubscription: PropTypes.oneOfType([PropTypes.object]).isRequired,
  email: PropTypes.string.isRequired
}

export default CancelInfo
